import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingEventsCard = ({ events }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="Calendar" size={20} color="var(--color-primary)" strokeWidth={2.5} />
        </div>
        <h3 className="text-lg font-bold text-foreground">Upcoming Cultural Events</h3>
      </div>
      <div className="space-y-4">
        {events?.map((event, index) => (
          <div 
            key={index}
            className="flex items-start gap-4 p-4 bg-muted/20 rounded-lg hover:bg-muted/30 transition-colors duration-200"
          >
            <div className="text-center shrink-0">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex flex-col items-center justify-center">
                <span className="text-xs font-semibold text-primary">{event?.month}</span>
                <span className="text-lg font-bold text-foreground">{event?.day}</span>
              </div>
            </div>
            <div className="flex-1">
              <h4 className="text-base font-semibold text-foreground mb-1">{event?.title}</h4>
              <p className="text-sm text-muted-foreground mb-2">{event?.description}</p>
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
                  <span>{event?.time}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
                  <span>{event?.location}</span>
                </div>
              </div>
            </div>
            <div className="shrink-0">
              <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                event?.type === 'mandatory' ?'bg-error/10 text-error' :'bg-success/10 text-success'
              }`}>
                {event?.type === 'mandatory' ? 'Required' : 'Optional'}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingEventsCard;